import React from 'react';
import '../css/Video.css'
import Button from './Button.js';
import VideoThumb from './VideoThumb.js';
const Section2 = ({ link }) => {
    return (
        <div className="section-container color">
            <div className="image-column">
                <VideoThumb videoUrl={"https://www.youtube.com/embed/ccCcany3fC4?si=fwYBTYtnkUBnxyLv&autoplay=1"} />

            </div>
            <div className="text-column">
                <h2 className='subtitle-section white'>Sobre o Curso</h2>

                <p className='text white'>Em um mundo cada vez mais <span className='yellow'>orientado por dados</span> , saber construir gráficos é fundamental.<br />
                    Aprenda a criar relatórios e dashboards que farão você se <span className='yellow'>destacar na sua área</span>.<br /><br />
                    <span className='yellow' style={{ "fontSize": "18px" }}>Para quem é esse curso?</span><br /><br />
                    Este curso foi pensado para iniciantes em análise de dados que desejam aprender a criar apresentações<span className='yellow'> dinâmicas, interativas e poderosas</span> , você não precisa entender de excel, pois de forma prática e direto ao ponto te guiarei passo a passo.<br /><br />
                    Aprenda no seu próprio ritmo e de qualquer lugar, e adquira habilidades essenciais no <span className='yellow'>tratamento de dados</span>, desde a limpeza e transformação até a preparação adequada para análise.<br /><br />
                    Descubra como criar <span className='yellow'>dashboards envolventes</span>, utilizando gráficos interativos que proporcionam uma experiência de visualização dinâmica e aprenda a comunicar suas descobertas de maneira clara e persuasiva.</p>

                <Button href={link} />
            </div>
        </div>
    );
};

export default Section2;
